import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewChild,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { UntilDestroy } from '@ngneat/until-destroy';

import { TagItemInfo } from '@blaze-shared/api-contracts-domain';
import { SelectComponent } from '@blaze-shared/shared-feature';
import { safeDetectChanges } from '@blaze-shared/shared-ui';

import { BaseCellInputComponent } from '../base-cell-input.component';

@UntilDestroy()
@Component({
  selector: 'blaze-cell-input-tag',
  templateUrl: './cell-input-tag.component.html',
  styleUrls: ['./cell-input-tag.component.scss', '../base-cell-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, SelectComponent, MatIcon],
})
export class CellInputTagComponent extends BaseCellInputComponent<string | string[]> {
  @Input() readonly = false;

  @ViewChild(SelectComponent) tagSelector?: SelectComponent;

  get availableTags(): (TagItemInfo & { label: string })[] {
    return (this.column?.tagDefinition?.items || []).map((tag) => ({ ...tag, label: tag.value }));
  }

  setSelectedTags(value: string | string[]): void {
    const columnTags = this.column?.tagDefinition?.items?.map((tag) => tag.value) || [];
    if (this.column?.multipleValues) {
      if (!Array.isArray(value)) {
        value = [value];
      }
      value = value.filter((v) => columnTags.includes(v));
      this.formControl.patchValue(value);
    } else {
      this.formControl.patchValue(value || '');
    }
    safeDetectChanges(this.cdr);
  }

  override focusMainElement(): void {
    afterNextRender(
      () => {
        if (!this.tagSelector?.isAutocompleteOpen) {
          this.tagSelector?.showOptions();
        }
      },
      { injector: this.injector },
    );
  }

  override executeExtraStartAction(): void {
    if (this.extraStartAction?.type === 'tag-add') {
      setTimeout(() => {
        this.focusMainElement();
      });
    } else if (this.extraStartAction?.type === 'tag-remove') {
      if (this.column.multipleValues && Array.isArray(this.value)) {
        const removedTag = this.extraStartAction.tag;
        const newValues = (this.value as string[])?.filter((v) => v !== removedTag);
        this.setSelectedTags(newValues);
      } else {
        this.setSelectedTags('');
      }
    }
  }
}
